import { createContext, FormEventHandler, useContext } from 'react';

import { FormState, LookupType } from '../types';

type FormContextState = FormState & {
  availableLookupTypes: LookupType[];
  identifier: string;
  isSubmitting: boolean;
  canSubmit: boolean;
  setIdentifier: (identifier: string) => void;
  setLookupType: (type: LookupType) => void;
  submit: FormEventHandler<HTMLFormElement>;
};

export const defaultState = {
  availableLookupTypes: [LookupType.ByEmail],
  identifier: '',
  isSubmitting: false,
  canSubmit: false,
  lookupType: LookupType.ByEmail,
  setIdentifier: () => null,
  setLookupType: () => null,
  submit: () => null,
};

export const FormContext = createContext<FormContextState>(defaultState);

export const useFormContext = () => useContext(FormContext);
